module.exports = __webpack_public_path__ + "assets/img/tracked-box1-icon2.23ac5698.svg";